import axios from "../../../../../../api/axiosInstance";
import { FetchMemberDashboardResponse } from "./types";

/**
 * No period is sent. The API defaults to its year-over-year window — the last
 * completed month and the twelve before it — and that is the only one the
 * dashboard shows, so asking for it by name would only be a second place for
 * the answer to be wrong.
 */
export const fetchMemberDashboard = async (
  signal?: AbortSignal,
): Promise<FetchMemberDashboardResponse> => {
  const response = await axios.get<FetchMemberDashboardResponse>(
    "/api/private/member-dashboard",
    { signal },
  );
  return response.data;
};
